export const buttonStyles = {
  primary: {
    background: "#4a90e2",
    color: "white",
    border: "none",
    padding: "0.55rem 0.95rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
  },
  secondary: {
    background: "white",
    color: "#4a90e2",
    border: "1px solid #4a90e2",
    padding: "0.5rem 0.85rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
  },
  chip: {
    background: "#f0f4fb",
    color: "#1f4f8b",
    border: "1px solid #c7d7f0",
    padding: "0.35rem 0.7rem",
    borderRadius: "999px",
    fontWeight: 600,
    cursor: "pointer",
  },
  success: {
    background: "#2e7d32",
    color: "white",
    border: "none",
    padding: "0.55rem 0.95rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
  },
  warning: {
    background: "#f0ad4e",
    color: "white",
    border: "none",
    padding: "0.55rem 0.95rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
  },
  danger: {
    background: "#d9534f",
    color: "white",
    border: "none",
    padding: "0.55rem 0.95rem",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
  },
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};

export const inputStyles = {
  input: {
    padding: "0.65rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #cfd7e3",
    fontSize: "1rem",
  },
  select: {
    padding: "0.6rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #cfd7e3",
    fontSize: "1rem",
    background: "white",
  },
  textarea: {
    padding: "0.65rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #cfd7e3",
    fontSize: "1rem",
    fontFamily: "inherit",
  },
};
